import type { Template } from "@/types";

export const PO_05_H3_V2: Template[] = [
    {
        id: "po-05-h3v2-01",
        name: "PO 01 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_01.png",
        size: [1190, 850],
        style: {},
        slots: [         
            { id: "1", x: 29, y: 207, width: 265, height: 435, rotation: 0, imageRotation: 0 },
            { id: "2", x: 302, y: 207, width: 265, height: 435, rotation: 0, imageRotation: 0 },
            { id: "3", x: 671, y: 207, width: 449, height: 282, rotation: 0, imageRotation: 0 },
            { id: "4", x: 671, y: 497, width: 221, height: 146, rotation: 0, imageRotation: 0 },
            { id: "5", x: 900, y: 497, width: 221, height: 146, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-02",
        name: "PO 02 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_02.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 41, y: 158, width: 508, height: 344, rotation: 0, imageRotation: 0 },
            { id: "2", x: 41, y: 509, width: 250, height: 182, rotation: 0, imageRotation: 0 },
            { id: "3", x: 299, y: 509, width: 250, height: 182, rotation: 0, imageRotation: 0 },
            { id: "4", x: 624, y: 207, width: 265, height: 435, rotation: 0, imageRotation: 0 },
            { id: "5", x: 897, y: 207, width: 265, height: 435, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-03",
        name: "PO 03 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_03.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 42, y: 144, width: 512, height: 366, rotation: 0, imageRotation: 0 },
            { id: "2", x: 42, y: 517, width: 123, height: 189, rotation: 0, imageRotation: 0 },
            { id: "3", x: 432, y: 517, width: 122, height: 189, rotation: 0, imageRotation: 0 },
            { id: "4", x: 172, y: 517, width: 252, height: 189, rotation: 0, imageRotation: 0 },
            { id: "5", x: 637, y: 242, width: 512, height: 366, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-04",
        name: "PO 04 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_04.png",
        size: [1190, 850],
        style: {},
        slots: [          
            { id: "1", x: 29, y: 208, width: 265, height: 435, rotation: 0, imageRotation: 0 },
            { id: "2", x: 302, y: 208, width: 265, height: 435, rotation: 0, imageRotation: 0 },
            { id: "3", x: 642, y: 158, width: 250, height: 182, rotation: 0, imageRotation: 0 },
            { id: "4", x: 642, y: 348, width: 508, height: 344, rotation: 0, imageRotation: 0 },
            { id: "5", x: 900, y: 158, width: 250, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-05",
        name: "PO 05 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_05.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 64, y: 239, width: 230, height: 372, rotation: 0, imageRotation: 0 },
            { id: "2", x: 302, y: 239, width: 229, height: 372, rotation: 0, imageRotation: 0 },
            { id: "3", x: 646, y: 192, width: 264, height: 465, rotation: 0, imageRotation: 0 },
            { id: "4", x: 918, y: 192, width: 212, height: 306, rotation: 0, imageRotation: 0 },
            { id: "5", x: 918, y: 506, width: 212, height: 151, rotation: 0, imageRotation: 0 },
  
        ],
    },

    {
        id: "po-05-h3v2-06",
        name: "PO 06 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_06.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 239, width: 471, height: 373, rotation: 0, imageRotation: 0 },
            { id: "2", x: 479, y: 239, width: 232, height: 373, rotation: 0, imageRotation: 0 },
            { id: "3", x: 719, y: 239, width: 232, height: 373, rotation: 0, imageRotation: 0 },
            { id: "4", x: 959, y: 239, width: 231, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 959, y: 430, width: 231, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-07",
        name: "PO 07 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_07.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 79, y: 135, width: 359, height: 579, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 446, y: 135, width: 397, height: 286, rotation: 0, imageRotation: 0 },
            { id: "3", x: 446, y: 429, width: 397, height: 285, rotation: 0, imageRotation: 0 },
            { id: "4", x: 851, y: 135, width: 259, height: 383, rotation: 0, imageRotation: 0 },
            { id: "5", x: 851, y: 526, width: 259, height: 188, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-08",
        name: "PO 08 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_08.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 66, y: 116, width: 382, height: 617, rotation: 0, imageRotation: 0 },
            { id: "2", x: 742, y: 116, width: 383, height: 617, rotation: 0, imageRotation: 0 },
            { id: "3", x: 455, y: 116, width: 279, height: 201, rotation: 0, imageRotation: 0 },
            { id: "4", x: 455, y: 325, width: 279, height: 200, rotation: 0, imageRotation: 0 },
            { id: "5", x: 455, y: 533, width: 279, height: 200, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-09",
        name: "PO 09 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_09.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 239, width: 471, height: 373, rotation: 0, imageRotation: 0 },
            { id: "2", x: 479, y: 239, width: 232, height: 373, rotation: 0, imageRotation: 0 },
            { id: "3", x: 959, y: 239, width: 231, height: 373, rotation: 0, imageRotation: 0 },
            { id: "4", x: 719, y: 239, width: 232, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 719, y: 430, width: 232, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-10",
        name: "PO 10 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_10.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 66, y: 116, width: 382, height: 617, rotation: 0, imageRotation: 0 },
            { id: "2", x: 456, y: 116, width: 381, height: 617, rotation: 0, imageRotation: 0 },
            { id: "3", x: 845, y: 116, width: 279, height: 201, rotation: 0, imageRotation: 0 },
            { id: "4", x: 845, y: 325, width: 279, height: 200, rotation: 0, imageRotation: 0 },
            { id: "5", x: 845, y: 533, width: 279, height: 200, rotation: 0, imageRotation: 0 }
        ],
    }
];